// The server keeps every {{response}} box in place and in order, so the key still scores each box.
export const mergeTypedAnswer = (jsonData, translated) => ({
  ...jsonData,
  stimulus: translated.stimulus ?? jsonData.stimulus,
  template: translated.template ?? jsonData.template,
});
